(function ($) {
    class RLM_VideoPopup {
        constructor () { 
            if ($('.js-play-video').length) {
                this.initEvents();
            }
        }

        initEvents () {
            let self = this;
            let videoLinks = $('.js-play-video');
            let ua = navigator.userAgent.toLowerCase();
            this.videoWrapper = $('#video-popup-overlay');
            this.videoContainer = $('.video-popup-inner-wrapper');
            this.isAndroid = ua.indexOf("android") > -1;

            for (let i = 0; i < videoLinks.length; i++) {
                videoLinks.eq(i).on('click', function (e) {
                    e.preventDefault();
                    self.videoWrapper.removeClass('is-hidden').addClass('is-visible');
                    self.videoContainer.html('<video src="' + $(this).attr('href') + '" autoplay playsinline></video>');

                    if (self.isAndroid && screen.orientation.type.indexOf('landscape') > -1) {
                        let videoElement = self.videoContainer.find('video')[0];

                        if (!videoElement) {
                            return;
                        }

                        if (videoElement.requestFullscreen) {
                            videoElement.requestFullscreen();
                        } else if (videoElement.mozRequestFullScreen) {
                            videoElement.mozRequestFullScreen();
                        } else if (videoElement.webkitRequestFullscreen) {
                            videoElement.webkitRequestFullscreen();
                        } else if (vidoeElement.msRequestFullscreen) {
                            videoElement.msRequestFullscreen();
                        }
                    }
                });
            }
            
            this.videoContainer.on('click', e => {
                if (e.target.tagName === 'VIDEO') {
                    if (!e.target.paused) {
                        e.target.pause();
                    } else {
                        if (this.isAndroid) {
                            if (e.target.requestFullscreen) {
                                e.target.requestFullscreen();
                            } else if (e.target.mozRequestFullScreen) {
                                e.target.mozRequestFullScreen();
                            } else if (e.target.webkitRequestFullscreen) {
                                e.target.webkitRequestFullscreen();
                            } else if (e.target.msRequestFullscreen) {
                                e.target.msRequestFullscreen();
                            }
                        }
    
                        e.target.play();
                    }
                }
            });
    
            this.videoWrapper.find('.video-popup-close').on('click', e => {
                e.preventDefault();
                this.videoWrapper.removeClass('is-visible');
                
                setTimeout(() => {
                    this.videoWrapper.addClass('is-hidden');
                    this.videoContainer.html('');
                }, 1000);
            });
        }
    }
    
    new RLM_VideoPopup();
})(jQuery);